import { useContext } from "react";
import { useLocation } from "react-router";
import { OrderEmployee } from "../../../../../../services/Api/Public/types";
import { OrderContext } from "../../contexts/OrderContext";
import { OrderTipEmployeeName } from "./components/OrderTipEmployeeName";
import { OrderTipForm } from "./components/OrderTipForm";
import { OrderTipInfo } from "./components/OrderTipInfo";

interface Props {
	employee?: OrderEmployee;
}

export const OrderTipSection = ({ employee }: Props) => {
	const { search } = useLocation();
	const urlSearchParams = new URLSearchParams(search);
	const paymentStatusParam = urlSearchParams.get("transactionStatus");
	const { orderId, alreadyGivenTip } = useContext(OrderContext);

	if (!employee?.accept_tips || paymentStatusParam || !orderId || alreadyGivenTip) {
		return null;
	}

	return (
		<section className="row-gap-2 mt-3" data-testid="order-tip-section">
			<OrderTipEmployeeName employeeName={employee.name} />
			<OrderTipForm />
			<OrderTipInfo />
		</section>
	);
};
